import { useRouter } from 'next/router';
import { FC, KeyboardEvent, ReactElement, useState } from 'react';

import Modal from '@components/Modal';
import { getUrl, IDENTIFIERS } from '@helpers/urlsHelper';
import Button from '@/components/DesignLibrary/Button';
import SearchInput from '@/components/FormFields/SearchInput';

import s from './WorkflowSearchModal.module.scss';

type Props = {
  onClose: () => void;
};

const WorkflowSearchModal: FC<Props> = ({ onClose }): ReactElement => {
  const router = useRouter();
  const [search, setSearch] = useState('');
  const [isRouting, setIsRouting] = useState(false);

  const handleClick = (): void => {
    if (search.length < 3) return;
    const url = getUrl(IDENTIFIERS.DASHBOARD_USER_WORKFLOWS, {
      search,
    });
    setIsRouting(true);
    router.push(url).then(() => {
      setIsRouting(false);
      onClose();
    });
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Modal title="Workflow Search" onClose={onClose}>
      <div className={s.container}>
        <SearchInput onKeyDown={handleKeyDown} placeholder="Search..." label="" setSearch={setSearch} autoFocus />
        <Button fullWidth variant="primary" size="md" onClick={handleClick} disabled={search.length < 3} loading={isRouting}>
          Search{isRouting ? 'ing' : ''} for workflow{isRouting ? '...' : ''}
        </Button>
      </div>
    </Modal>
  );
};

export default WorkflowSearchModal;
